import Autocomplete from '@mui/material/Autocomplete';
import styled from 'styled-components';

export const CustomAutocomplete = styled(Autocomplete)`
  && .MuiAutocomplete-popupIndicatorOpen {
    transform: none;
    color: green;
  }
`;
